import { html } from "lit";

export default (o) => html`<img class="chat-image chat-image--modal" src="${o.src}">`;
